import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Entity from "../datasource/Entity";
import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";

class ServiceCategoriesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("service_categories");
    }

    getBackLink = () => this.datasource.routes().home;

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title="Список категорий услуг"
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            order: "Порядок",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        removeAction={this.removeItem}
                        updateParticularItem={this.updateParticularItem}
                        defaultSortfield="order"
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новая категория услуги"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        getDefaultValues={this.getPaymentTypes}
                        defaultValues={this.state.defaultPaymentTypes}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title="Просмотр категории услуги"
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        getDefaultValues={this.getPaymentTypes}
                        defaultValues={this.state.defaultPaymentTypes}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        getDefaultValues={this.getPaymentTypes}
                        defaultValues={this.state.defaultPaymentTypes}
                    />
                </Route>
            </Switch>
        );
    };
}

export default ServiceCategoriesContainer;
